import wixLocation from 'wix-location';
import wixUsers from 'wix-users';

const logUrl = wixLocation.url.indexOf('wix.com') > -1 ? 'https://frog.wix.com/' : 'https://frog.editorx.com';

export function log(eventData) {
  let logURI = `${logUrl}gdpr?src=5`
  eventData.url = wixLocation.url;
  eventData.policy = 'cookie';
  Object.keys(eventData).forEach((key) => {
    logURI += `&${encodeURIComponent(key)}=${encodeURIComponent(
      eventData[key],
    )}`
  })
  fetch(logURI);
}

export function savePolicy(advertising){
    return wixUsers.setConsentPolicy({essential: true, functional: true, analytics: true, advertising, dataToThirdParty: advertising});
}

export function getPolicy(){
  const { defaultPolicy, policy } = wixUsers.getCurrentConsentPolicy();
  return {
    defaultPolicy,
    ...policy
  };
}